import { Heading } from './Heading';
export const HeadingV2 = Heading;
//# sourceMappingURL=HeadingV2.js.map